<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Cadastro de Usuário</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="nome">Nome</label>
                  <input type="text" class="form-control" id="nome" formControlName="nome" [readonly]="!isEditing">
                  <div class="invalid-feedback" *ngIf="usuarioForm.get('nome').invalid && usuarioForm.get('nome').touched">
                    Nome é obrigatório
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="login">Login</label>
                  <input type="text" class="form-control" id="login" formControlName="login" [readonly]="!isEditing">
                  <div class="invalid-feedback" *ngIf="usuarioForm.get('login').invalid && usuarioForm.get('login').touched">
                    Login é obrigatório
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <button type="button" class="btn btn-primary mr-2" (click)="toggleEdit()">
                  {{ isEditing ? 'Cancelar' : 'Adicionar Novo' }}
                </button>
                <button type="submit" class="btn btn-success" [disabled]="!isEditing || !usuarioForm.valid">
                  {{ isEditing ? 'Salvar Alterações' : 'Salvar' }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de Usuários -->
  <div class="row mt-4">
    <div class="col-12">
      <app-card cardTitle="Usuários Cadastrados" blockClass="table-border-style" [options]="false">
        <div class="table-responsive">
          <div *ngIf="usuarios.length === 0" class="text-center p-4">
            <i class="feather icon-database f-24"></i>
            <p class="mt-2">Nenhum usuário cadastrado</p>
          </div>
          <table *ngIf="usuarios.length > 0" datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Login</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuario of usuarios">
                <td>{{ usuario.id }}</td>
                <td>{{ usuario.nome }}</td>
                <td>{{ usuario.login }}</td>
                <td>
                  <span [class]="usuario.ativo ? 'badge badge-success' : 'badge badge-danger'">
                    {{ usuario.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary mr-1" (click)="editarUsuario(usuario)">
                    <i class="feather icon-edit"></i>
                  </button>
                  <button class="btn btn-sm" [class]="usuario.ativo ? 'btn-warning' : 'btn-success'" (click)="inativarUsuario(usuario)">
                    <i class="feather" [class]="usuario.ativo ? 'icon-user-x' : 'icon-user-check'"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
  </div>
</div> 